import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { WalletProvider } from "@/context/WalletContext";
import Layout from "@/components/layout/Layout";
import Landing from "@/pages/Landing";
import Overview from "@/pages/Overview";
import BuyStake from "@/pages/BuyStake";
import Calculator from "@/pages/Calculator";
import Referral from "@/pages/Referral";
import Ranks from "@/pages/Ranks";
import Levels from "@/pages/Levels";
import Shares from "@/pages/Shares";
import Pools from "@/pages/Pools";
import Prediction from "@/pages/Prediction";
import Withdrawals from "@/pages/Withdrawals";
import Admin from "@/pages/Admin";
import Docs from "@/pages/Docs";

function RefCapture() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("croc_ref", ref);
  }, []);
  return null;
}

function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <RefCapture />
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0F1712",
              border: "1px solid rgba(229,72,77,0.3)",
              color: "#F3F4F6",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route element={<Layout />}>
            <Route path="/overview" element={<Overview />} />
            <Route path="/buy" element={<BuyStake />} />
            <Route path="/tiers" element={<Navigate to="/buy" replace />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/referral" element={<Referral />} />
            <Route path="/ranks" element={<Ranks />} />
            <Route path="/levels" element={<Levels />} />
            <Route path="/shares" element={<Shares />} />
            <Route path="/pools" element={<Pools />} />
            <Route path="/prediction" element={<Prediction />} />
            <Route path="/withdraw" element={<Withdrawals />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/docs" element={<Docs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </WalletProvider>
  );
}

export default App;
